import { atom } from 'jotai';
import {atomWithStorage} from "jotai/utils";
import CommonClass from "@/utils/common.ts";
import {SyncStorage} from "jotai/vanilla/utils/atomWithStorage";
import SnackbarNotificationInterface from "@/types_and_interfaces/snackbar_notification_interface.ts";
import CalculatorLimitTypes from "@/types_and_interfaces/calculator_limit_types.ts";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import LoanApplicationTypesInterface from "@/types_and_interfaces/loan_types_interface.ts";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import NotificationInterface from "@/types_and_interfaces/notification_interface.ts";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";


const customLocalStorage: SyncStorage<string> = {
    getItem(key: string) {
        const value = localStorage.getItem(key);
        return value !== null ? value : '';
    },
    setItem(key: string, value: string | null) {
        if (value === null || value === undefined) {
            localStorage.removeItem(key); // Remove the item from local storage
        } else {
            localStorage.setItem(key, value);
        }
    },
    removeItem(key: string) {
        localStorage.removeItem(key);
    },
};

export const resend_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.resend_interval,
    '',
    customLocalStorage
);
export const edit_email_otp_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.edit_email_otp_interval,
    '',
    customLocalStorage
);

export const edit_phone_otp_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.edit_phone_otp_interval,
    '',
    customLocalStorage
);

export const login_back_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.login_back_interval,
    '',
    customLocalStorage
);

export const sign_contract_otp_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.sign_contract_otp_interval,
    '',
    customLocalStorage
);

export const refresh_interval = atomWithStorage<string>(
    CommonClass.local_storage_fields.refresh_interval,
    '',
    customLocalStorage
);

export const is_mobile = atom<boolean>(false);
export const notificationsList = atom<Array<SnackbarNotificationInterface>>([]);
export const popping_notifications = atom<Array<NotificationInterface>>([]);
export const file_input_loaded = atom<boolean>(false);
export const cr_line_data = atom<any>(undefined);
export const all_inits = atom<any>(false);
export const pin_value = atom<Array<any>>(['', '', '', '']);
export const pwd_value = atom<Array<any>>(['', '', '', '']);
export const two_page_doc = atom<Array<any>>([]);
export const calculator_limits = atom<CalculatorLimitTypes | undefined | {}>(undefined)
export const selected_calculator_type = atom<CalculatorLimit | undefined | {}>(undefined)
export const calculator_product = atom<ProductInterface | undefined | {}>(undefined)
export const pending_loans = atom<LoanApplicationTypesInterface | undefined | {}>(undefined)
export const contract = atom<Record<any, any>>({});
export const cr_line_contract = atom<Record<any, any>>({});
export const contract_pg_nr = atom<any>(0)
export const succeded_application = atom<CreditApplicationInterface | undefined>(undefined)
export const succeded_transaction = atom<CrLineTransactionInterface | undefined>(undefined)
export const refresh_button_show = atom<boolean>(false)





